import { render, staticRenderFns } from "./index.vue?vue&type=template&id=05bfce2d&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=05bfce2d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05bfce2d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/zklink/web/zklink-explorer-web-build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('05bfce2d')) {
      api.createRecord('05bfce2d', component.options)
    } else {
      api.reload('05bfce2d', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=05bfce2d&scoped=true&", function () {
      api.rerender('05bfce2d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Link/index.vue"
export default component.exports